/**
 * Quick add (F1 / D2).
 *
 * Only rendered for single-variant products, so there is never a variant to
 * choose here — it is a one-click add that hands off to Velocity.addToCart,
 * which owns the request and opens the cart drawer.
 */
(function () {
  'use strict';

  var V = window.Velocity;
  if (!V) return;

  class QuickAdd extends V.Element {
    init() {
      this.button = this.querySelector('[data-quick-add]');
      if (!this.button) return;
      this.on(this.button, 'click', this.add.bind(this));
    }

    add() {
      var self = this;
      var btn = this.button;
      if (btn.getAttribute('aria-busy') === 'true') return;

      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;

      V.addToCart({ id: btn.dataset.variantId, quantity: 1 })
        .catch(function (err) {
          // Surface the reason in place — the drawer will not open on failure.
          btn.textContent = err.message || (V.strings && V.strings.soldOut) || '';
        })
        .then(function () {
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
          self.blurIfDetached();
        });
    }

    /* The cart drawer takes focus on open; if this button is still in the DOM
       leave focus alone, otherwise the browser drops it to <body>. */
    blurIfDetached() {
      if (!document.contains(this.button)) return;
    }
  }

  V.define('quick-add', QuickAdd);
})();
